module.exports = __webpack_public_path__ + "img/bassic-badge.c67baeee.png";